import React, { Component } from 'react'
import { selectors, actions } from '../sagas/reservation/confirmation'
import { reduxForm } from 'redux-form';
import { selectors as reservation_selectors } from '../sagas/reservation'
import { actions as reservation_actions } from '../sagas/reservation'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { TextInput } from '../shared/TextInput';
import moment from 'moment'
import _ from 'lodash'
import '../stylesheets/Reservations.css'
import '../stylesheets/confirmation.sass'

class FormStepThree extends Component {
  constructor(props) {
    super(props)
    this.backOneStep = this.props.actions.reservation_actions.backOneStep.bind(this)
  }

  handleCustomSubmit = () => {
    let orderId = this.props.order
      && this.props.order.id
    this.props.actions.reservation_actions.submitDiscount(orderId, this.props.company_id)
  }

  verifyReservation = () => {
    let orderId = this.props.order
      && this.props.order.id
    this.props.actions.reservation_actions.verifyReservation(orderId, this.props.company_id)
  }

  payAtPickUp = () => {
    this.props.actions.reservation_actions.cheersPage()
    this.verifyReservation()
  }

  payNow = () => {
    this.props.actions.reservation_actions.resetForms()
    this.verifyReservation()
  }

  collectTips = () => {
    return this.props.publicInfo.collectTips && false
  }

  render () {
    let { handleSubmit, order_information } = this.props
    let customer_info = (order_information) => {
      return order_information && order_information.filter(object => {
        return object.type === 'customers'
      })
    }

    let inventory_info = (order_information) => {
      return order_information && order_information.filter(object => {
        return object.type === 'inventory'
      })
    }

    let info = customer_info(order_information)[0].attributes
    let order_prices = this.props.order['attributes'] && this.props.order['attributes']['price']

    console.log(this.props.publicInfo)
    return (
      <div className={'confirmation'}>
        { info &&
          <div className={'order-confirmation'}>
            <label>
              Order For
            </label>
            <div className={'order-info'}>
              <div className={'name order-info-value'}>
                { `${info['firstName']} ${info['lastName']}` }
              </div>
              <div className={'street-address order-info-value'}>
                { info['streetAddress'] }
              </div>
              <div className={'city order-info-value'}>
                { info['city'] }
              </div>
              <div className={'state order-info-value'}>
                { info['state'] }
              </div>
              <div className={'zip order-info-value'}>
                { info['zip'] }
              </div>
              <div className={'email order-info-value'}>
                { info['email'] }
              </div>
              <div className={'phone-number order-info-value'}>
                { info['phoneNumber'] }
              </div>
            </div>
            <div className={'drivers-license'}>
              <label>
                Drivers License
              </label>
              <div className={'order-info-value'}>
                { info['driverLicense'] }
              </div>
            </div>
            <div className={'birthdate info-date'}>
              <div>
                <label>
                  Birthdate
                </label>
              </div>
              <div className={'info-date-date'}>
                { moment(info['birthDate']).format('MM/DD/YYYY') }
              </div>
            </div>
            <div className={'info-date'}>
              <label>
                Pick Up Date
              </label>
              <div className={'info-date-date'}>
                { this.props.pick_up_date.format('MM/DD/YYYY') }
              </div>
            </div>
            <div className={'info-date'}>
              <label>
                Return Date
              </label>
              <div className={'info-date-date'}>
                { this.props.return_date.format('MM/DD/YYYY') }
              </div>
            </div>
          </div>
        }
        <div className={'itemized-kegs'}>
          { inventory_info(order_information)
            && inventory_info(order_information).map(inventory => {
             let inventory_attributes = inventory.attributes
             return (
                <div className={'keg-info'}>
                  <div>
                    { inventory_attributes['name'] }
                  </div>
                  <div>
                    { _.startCase(inventory_attributes['sizeOfKeg']) }
                  </div>
                  <div>
                    ${ inventory_attributes['price'] }
                  </div>
                </div>
              )
            })
          }
        </div>
        { order_prices &&
            <div className={'pricing'}>
              <div className={'deposit'}>
                <label className={'subtitle'}>
                  Deposits
                </label>
                <div className={'explanation'}>
                  90 days after your estimated return date your deposit will be collected unless the kegs and hand taps are returned or we are contacted.
                </div>
              </div>
              <div className={'service-fee price-info'}>
                <label>
                  Keg Deposit
                </label>
                <div>
                  ${ order_prices['kegDeposit'] }
                </div>
              </div>
              <div className={'sales-tax price-info'}>
                <label>
                  Hand Tap Deposit
                </label>
                <div>
                  ${ order_prices['handTapDeposit'] }
                </div>
              </div>
              <div className={'price-info'}>
                <label>
                  Total Deposit
                </label>
                <div>
                  ${ order_prices['totalDeposit'] }
                </div>
              </div>
            </div>
        }
        <div>
        { order_prices &&
            <div className={'pricing'}>
              <div className={'price'}>
                <label className={'subtitle'}>
                  Price
                </label>
                <div className={'explanation'}>
                  This is what we charge you for your beer today
                </div>
              </div>
              <div className={'keg-price price-info'}>
                <div>
                  <label>
                    Keg Prices
                  </label>
                </div>
                <div>
                  ${ order_prices['kegPrices'] }
                </div>
              </div>

              <div className={'keg-price price-info'}>
                <div>
                  <label>
                    Hand Tap Prices
                  </label>
                </div>
                <div>
                  ${ order_prices['handTapPrices'] }
                </div>
              </div>

              { order_prices && order_prices['passOn'] &&
                <div className={'service-fee price-info'}>
                  <label>
                    Service Fee
                  </label>
                  <div>
                    ${ order_prices['serviceFee'] }
                  </div>
                </div>
              }
              { order_prices && order_prices['displaySalesTax'] &&
                <div className={'sales-tax price-info'}>
                  <label>
                    Sales Tax
                  </label>
                  <div>
                    ${ order_prices['tax'] }
                  </div>
                </div>
              }
              <div className={'total price-info'}>
                <label className={'total'}>
                  Total
                </label>
                <div className={'total'}>
                  ${ order_prices['totalPrice'] }
                </div>
              </div>
            </div>
        }
        <form className={'discount-code-form'} onSubmit={handleSubmit(this.handleCustomSubmit)}>
          <TextInput
            inputClass='reservation-input'
            inputName='discount'
            placeholderText='Discount Code'
            label='Dicount Code'
            required
          />
          <button className='apply-discount'>
            Apply Discount
          </button>
        </form>
      </div>
        <div className={'buttons'}>
          <div className={'checkout-buttons'}>
            <button className='reservation-cancel' onClick={ this.backOneStep } >
              Go Back
            </button>
            <Link onClick={ this.payNow } to={{ pathname: this.collectTips() ? `/tips/${this.props.order.id}` : `/checkout/${this.props.order.id}`, state: { type: 'card' }}}>
              <button onClick={ this.props.actions.reservation_actions.resetForms } className='reservation-save'>
                Checkout
              </button>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  confirmation_store: selectors.confirmation_store(store),
  reservation: reservation_selectors.reservation(store),
  order: reservation_selectors.order(store),
  order_information: reservation_selectors.order_info(store),
  pick_up_date: reservation_selectors.pick_up_date(store),
  return_date: reservation_selectors.return_date(store),
  discounts_form: reservation_selectors.discounts_form(store),
  initialValues: reservation_selectors.initValues(store),
  publicInfo: reservation_selectors.publicInfo(store)
})

const mapDispatchToProps = (dispatch) => {
  return ({
    actions: {
      confirm_actions: bindActionCreators(actions, dispatch),
      reservation_actions: bindActionCreators(reservation_actions, dispatch),
    }
  })
}

export default (connect
  (mapStateToProps, mapDispatchToProps)(
  reduxForm(
    {
      form: 'discounts',
      destroyOnUnmount: false
    }
  )(FormStepThree)))



// WEBPACK FOOTER //
// ./src/Reservations/FormThree.jsx